<div
  *appHasPermission="{ resource: Resources.Reports, scope: Scopes.Read }"
  class="reports-container"
  [ngClass]="{ 'sidebar-open': sideComponentOpen }"
>
  <p class="tab-title">Reports</p>

  <!-- Tabs -->
  <div class="tabs" appTabStrip="Report sections">
    <!-- Transaction History Tab -->
    <button
      *appHasPermission="[{ resource: Resources.Reports, scope: Scopes.Read }]"
      class="tab"
      [ngClass]="{ active: activeTab === 'Transaction History' }"
      (click)="selectTab('Transaction History')"
    >
      <mat-icon class="tab-icon">access_time_filled</mat-icon>
      <span class="tab-text" data-text="Transaction History">Transaction History</span>
    </button>

    <!-- Wallets Tab -->
    <!-- TODO: backend must remove the endpoints -->
    @if (isSettlementApp) {
    <button
      *appHasPermission="[{ resource: Resources.Reports, scope: Scopes.Read }]"
      class="tab"
      [ngClass]="{ active: activeTab === 'Wallets' }"
      (click)="selectTab('Wallets')"
    >
      <mat-icon class="tab-icon">wallet</mat-icon><span class="tab-text" data-text="Wallets">Wallets</span>
    </button>
    }

    <!-- User Activity Tab -->
    <button
      *appHasPermission="[{ resource: Resources.Logs, scope: Scopes.Read }]"
      class="tab"
      [ngClass]="{ active: activeTab === 'User Activity' }"
      (click)="selectTab('User Activity')"
    >
      <mat-icon class="tab-icon">groups</mat-icon><span class="tab-text" data-text="User Activity">User Activity</span>
    </button>

    @if (isSettlementApp) {
    <button
      *appHasPermission="{ resource: Resources.DelegationConfiguration, scope: Scopes.Read }"
      class="tab"
      [ngClass]="{ active: activeTab === 'Utilization' }"
      (click)="selectTab('Utilization')"
    >
      <mat-icon class="tab-icon">insights</mat-icon><span class="tab-text" data-text="Utilization">Utilization</span>
    </button>
    }

    <!-- Ledger Tab -->
    <button
      *appHasPermission="[{ resource: Resources.Ledger, scope: Scopes.Read }]"
      class="tab"
      [ngClass]="{ active: activeTab === 'Ledger' }"
      (click)="selectTab('Ledger')"
    >
      <mat-icon class="tab-icon">work</mat-icon><span class="tab-text" data-text="Ledger">Ledger</span>
    </button>

    <!-- Assets Tab -->
    <button
      *appHasPermission="[{ resource: Resources.Assets, scope: Scopes.Read }]"
      class="tab"
      [ngClass]="{ active: activeTab === 'Assets' }"
      (click)="selectTab('Assets')"
    >
      <mat-icon class="tab-icon">payments</mat-icon><span class="tab-text" data-text="Assets">Assets</span>
    </button>
  </div>

  <!-- Transaction History Tab Content -->
  @if (activeTab === 'Transaction History') {
  <div class="tab-content" *appHasPermission="[{ resource: Resources.Reports, scope: Scopes.Read }]">
    <app-reports-transaction-history [initialSearch]="transactionSearch" />
  </div>
  }

  <!-- Wallets Tab Content -->
  @if (activeTab === 'Wallets') {
  <div class="tab-content" *appHasPermission="[{ resource: Resources.Reports, scope: Scopes.Read }]">
    <app-reports-wallets />
  </div>
  }

  <!-- User Activity Tab Content -->
  @if (activeTab === 'User Activity') {
  <div class="tab-content" *appHasPermission="[{ resource: Resources.Logs, scope: Scopes.Read }]">
    <app-reports-user-activity />
  </div>
  }

  @if (activeTab === 'Utilization' && isSettlementApp) {
  <div class="tab-content" *appHasPermission="{ resource: Resources.DelegationConfiguration, scope: Scopes.Read }">
    <app-reports-utilization />
  </div>
  }

  <!-- Ledger Tab Content -->
  @if (activeTab === 'Ledger') {
  <div class="tab-content" *appHasPermission="[{ resource: Resources.Ledger, scope: Scopes.Read }]">
    <app-reports-ledger />
  </div>
  }
  <!-- Assets Tab Content -->
  @if (activeTab === 'Assets') {
  <div class="tab-content" *appHasPermission="[{ resource: Resources.Assets, scope: Scopes.Read }]">
    <app-reports-assets />
  </div>
  }
</div>
